import React, { useEffect } from "react";
import ContactBanner from "../components/contact/ContactBanner";
import ContactJoin from "../components/contact/ContactJoin";
import { useLenis } from "lenis/react";

const ContactPage = () => {
  const lenis = useLenis();
  useEffect(() => {
    if (lenis) {
      lenis.scrollTo(0, {
        duration: 1.2,
      });
    }
  }, [lenis]);
  return (
    <>
      <ContactBanner />
      <ContactJoin />
    </>
  );
};

export default ContactPage;
